import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49e63758"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-10" }, "部门岗位维护", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("新增部门")
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "department-content" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "treeBtn" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("添加部门")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("添加岗位")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_11 = {
  style: {"width":"400px"},
  class: "department-content"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("删除")

import { Ref, ref, getCurrentInstance, ComponentInternalInstance, onBeforeMount, reactive } from 'vue'
import tbMix from '@/global_mixin/tableMixin'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
    // 获取岗位列表
    'GET/jobs': jobsListApi,
    // 获取部门(树状)
    'GET/departments/tree': departmentsTreeApi,
    // 删除部门
    'DELETE/departments/{departmentId}': delDepartment,
    // 修改岗位
    'PATCH/jobs': jobsModifyApi,
    // 删除岗位
    'DELETE/jobs/{id}': delJobsApi,
    // 添加部门
    'POST/departments': departmentsApi,
    // 新增岗位
    'POST/jobs': addJobApi,
    // 修改部门
    'PATCH/departments': modifyDepartmentApi,
} = Api


let { MI_tableData, fetchData, page, size, MI_total, MI_pageChange, MI_identify, MI_modifyForm } = new tbMix(jobsListApi)
const { appContext } = getCurrentInstance() as ComponentInternalInstance
const globalProperties = appContext.config.globalProperties


let departmentJobsData: Ref<object[]> = ref([])


const initializationFunc = () => {
    departmentsTreeApi().then((rep: any) => {
        departmentJobsData.value = rep
    })
}
onBeforeMount(() => {
    initializationFunc()
})


// 查看岗位
let currentDepartmentName: Ref<string> = ref('-')
let currentDepartment = {}
const showJobs = (data: any) => {
    if(data.level === 1) return;
    
    currentDepartmentName.value = data.name
    currentDepartment = data
    
    
    fetchData({departmentId: data.departmentId})
}

// 删除岗位
const deleteJob = (row: { id: string, name: string }) => {
    globalProperties.$msgbox.confirm(
        `是否删除: ${row.name} 岗位`,
        '提示',
    )
        .then(() => {
            return delJobsApi({id: row.id})
        })
        .then(() => {
            globalProperties.$message({
                message: '删除成功',
                type: 'success',
            })
            showJobs(currentDepartment)
        })
        .catch(() => { })

}
// 删除部门
const deleteDepartment = (data: any)  => {
    globalProperties.$msgbox.confirm(
        `是否删除: ${data.name} 部门`,
        '提示',
    )
        .then(() => {
            return delDepartment(data)
        })
        .then(() => {
            globalProperties.$message({
                message: '删除成功',
                type: 'success',
            })
            initializationFunc()
        })
        .catch(() => { })

}

// 新增部门
const addDepartment = (data: any) => {
    globalProperties.$msgbox.prompt('请输入新增部门名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
    })
        .then(({ value }: any) => {
            return departmentsApi({pid: data.departmentId, level: data.level + 1, name: value})
        })
        .then(() => {
            globalProperties.$message({
                message: '添加成功',
                type: 'success',
            })
            return departmentsTreeApi()
        })
        .then((rep: Array<{ children: [] }>) => {
            departmentJobsData.value = rep
        })
        .catch(() => { })
    
}

// 新增岗位
const additonFg: Ref<boolean> = ref(false)
const additonConfig = ref([
    {
        label: '岗位名称',
        value: '',
        upKey: 'name',
        rule:[
           { required: true, message: '必选项', trigger: 'change' },
        ]
    },
    {
        label: '职级',
        value: '',
        upKey: 'classOfPosition',
        props: {placeholder: '请输入职级(数字)'}
    },
    
])
// 新增岗位
const additonHandle = (data: any) => {
    MI_modifyForm({}, additonConfig, additonFg).then(params => {
        additonFg.value = false
        return addJobApi({...data, ...params})
    })
        .then(() => {
            globalProperties.$message({
                message: '添加成功',
                type: 'success',
            })
            showJobs(currentDepartment)
        })
    
    
}
// 修改部门名称
const modifyDepartment = (data: any) => {
    
    globalProperties.$msgbox.prompt('请输入修改后部门名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: data.name
    })
        .then(({ value }: any) => {
            return modifyDepartmentApi({ ...data, name: value })
        })
        .then(() => {
            globalProperties.$message({
                message: '修改成功',
                type: 'success',
            })
            return departmentsTreeApi()
        })
        .then((rep: Array<{ children: [] }>) => {
            departmentJobsData.value = rep
        })
        .catch(() => { })

}

// 修改岗位
const isShowEdit = ref<boolean>(false)
const modifyJobs = (row: { id: string | number }) => {
    MI_modifyForm(row, additonConfig, isShowEdit).then(params => {
        isShowEdit.value = false
        return jobsModifyApi({...row, ...params})
    })
        .then(() => {
            globalProperties.$message({
                message: '修改成功',
                type: 'success',
            })
            showJobs(currentDepartment)
        })
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (addDepartment({departmentId: 0, level: 0})))
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_tree, {
          data: _unref(departmentJobsData),
          "node-key": "departmentId",
          "default-expand-all": "",
          "expand-on-click-node": false,
          props: { label: 'name' }
        }, {
          default: _withCtx(({ node, data }) => [
            _createElementVNode("div", {
              class: "custom-tree-node",
              onClick: ($event: any) => (showJobs(data))
            }, [
              _createElementVNode("span", null, _toDisplayString(node.label), 1),
              _createElementVNode("p", _hoisted_6, [
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: ($event: any) => (modifyDepartment(data))
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                (node.level === 1)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      size: "small",
                      onClick: ($event: any) => (addDepartment(data))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (node.level === 2)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      size: "small",
                      onClick: ($event: any) => (additonHandle(data))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_button, {
                  size: "small",
                  type: "danger",
                  onClick: ($event: any) => (deleteDepartment(data))
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ], 8, _hoisted_5)
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_el_tag, { class: "mb-5" }, {
          default: _withCtx(() => [
            _createTextVNode("当前部门：" + _toDisplayString(_unref(currentDepartmentName)), 1)
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          "max-height": "75vh",
          border: "",
          data: _unref(MI_tableData)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "岗位",
              prop: "name"
            }),
            _createVNode(_component_el_table_column, { label: "操作" }, {
              default: _withCtx(({row}) => [
                _createVNode(_component_el_space, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_link, {
                      type: "primary",
                      onClick: ($event: any) => (modifyJobs(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_link, {
                      type: "danger",
                      onClick: ($event: any) => (deleteJob(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _unref(MI_identify)]
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: "添加岗位",
      draggable: "",
      width: "600px",
      modelValue: additonFg.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((additonFg).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_alert, {
          title: '当前新增岗位所属部门: ' + _unref(currentDepartmentName),
          type: "info",
          closable: false,
          effect: "dark"
        }, null, 8, ["title"]),
        (additonFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
                    searchConfig: additonConfig.value,
                    submitText: '确定'
                })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "修改岗位",
      draggable: "",
      width: "600px",
      modelValue: isShowEdit.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isShowEdit).value = $event))
    }, {
      default: _withCtx(() => [
        (isShowEdit.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
                    searchConfig: additonConfig.value,
                    submitText: '确定'
                })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})